import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap'
import '@fortawesome/fontawesome-free/js/all.js'
import Router from './router';

ReactDOM.render( < Router /> , document.getElementById("root"))